import { render, staticRenderFns } from "./CooperativePriceDetail.vue?vue&type=template&id=574ec1d4&scoped=true&"
import script from "./CooperativePriceDetail.vue?vue&type=script&lang=js&"
export * from "./CooperativePriceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574ec1d4",
  null
  
)

export default component.exports